import { EncodingOperation } from 'namirasoft-core';

export class HashOperation
{
    static async SHA256(message: string): Promise<string>
    {
        const encoder = new TextEncoder();
        const data = encoder.encode(message);
        const hashBuffer = await crypto.subtle.digest("SHA-256", data);

        return [...new Uint8Array(hashBuffer)].map(b => b.toString(16).padStart(2, "0")).join("");
    }

    static async hashEntry(username: string, url: string): Promise<string>
    {
        let hostname: string;
        try
        {
            const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`;
            hostname = new URL(normalized).hostname.replace(/^www\./i, "");
        }
        catch
        {
            hostname = url;
        }
        let message = EncodingOperation.Base64Encode(username + hostname);
        return HashOperation.SHA256(message);
    }
}